<div class="labelled-item-container">
    <span class="item-label">{{label}}</span>
    <div class="item">
        <ion-text [color]="color">{{value}}</ion-text>
    </div>
</div>
